import { filterFields } from "../utils.js";

export class ItemProcessor {
  constructor(storage, pipeService, req, appProcessor, util) {
    this.storage = storage;
    this.pipeService = pipeService;
    this.req = req;
    this.appProcessor = appProcessor;
    this.util = util;
    this.itemListeners();
  }

  async addItemsApi(app_id, itemsList) {
    try {
      const response = await this.req.post({
        url: "/api/items/add",
        form: { items: JSON.stringify(itemsList), app_id },
      });
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async updateItemsApi(app_id, itemsList) {
    try {
      const response = await this.req.post({
        url: "/api/items/update",
        form: { items: JSON.stringify(itemsList), app_id },
      });
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  deleteItemsApi(items_ids) {
    try {
      const response = this.req.post({
        url: "/api/items/delete",
        form: { items_ids: JSON.stringify(items_ids)},
      });
      response.from_apps_list = true;
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async addItemsToStorage(app_id, items) {
    // !!!!! Need to fix this
    const app = await this.appProcessor.getApp(app_id);
    if (app) {
      items.forEach((item) => {
        app.items_list.push(item);
        app.items_object[item.item_id] = {};
        for(let field = 0; field < item.fields.length; field++) {
          app.items_object[item.item_id][item.fields[field].field_id] = item.fields[field];
        }
        this.pipeService.emit("gh_item_update", { app_id }, [item]);
      });
      this.pipeService.emit("gh_items_update", { app_id }, app.items_list);
      this.storage.updateApp(app);
    }
    return app;
  }

  async updateItemsInStorage(app_id, items) {
    this.pipeService.emit("gh_items_update", { app_id }, items);
    //-- getting app from storage
    const app = await this.appProcessor.getApp(app_id);
    if (app && items) {
      items.forEach((item) => {
        const addressToEmit = { app_id };
        this.pipeService.emit("gh_item_update", addressToEmit, [item]);
        addressToEmit.item_id = item.item_id;
        this.pipeService.emit("gh_item_update", addressToEmit, item);
        //-- Looking for updated item in the main storage according to 'item_id'
        const fundedItem = app.items_list.find(
          (storageItem) => storageItem.item_id == item.item_id
        );
        if (fundedItem) {
          //-- Updating value in existing fields
          item.fields.forEach((field) => {
            const fundedField = fundedItem.fields.find(
              (storageField) => storageField.field_id == field.field_id
            );
            addressToEmit.field_id = field.field_id;
            if (fundedField) {
              //-- Checking if value of existing fields were updated, because we are not sending updates if value didn't changed
              if (fundedField.field_value != field.field_value) {
                fundedField.field_value = field.field_value;
                app.items_object[fundedItem.item_id][fundedField.field_id] = fundedField;

                this.pipeService.emit(
                  "gh_value_update",
                  addressToEmit,
                  field.field_value
                );
              }
            } else {
              //-- Pushing new fields to the storage (it's when user enters new value)
              fundedItem.fields.push(field);
              app.items_object[fundedItem.item_id][field.field_id] = field;
              this.pipeService.emit(
                "gh_value_update",
                addressToEmit,
                field.field_value
              );
            }
          });
        }
      });
    }
    return items;
  }

  //here

  /////
  handleItemsChange(id, prevVersion, nextVersion) {
    let compareRes = this.util.compareItems(prevVersion.items_list, nextVersion.items_list);

    this.updateItemsInStorage(id, compareRes.diff_src_items);
    this.addItemsToStorage(id, compareRes.new_src_items);
  }


  //
  triggerItemsChange(id, compareRes) {
    this.updateItemsInStorage(id, compareRes.diff_src_items);
    this.addItemsToStorage(id, compareRes.new_src_items);
  }

  //
  handleDiff(id, compare) {
    this.updateItemsInStorage(id, compare.diff_src_items);
    this.addItemsToStorage(id, compare.new_src_items);
    this.deleteItemsFromStorage(id, compare.trash_src_items);
  }

  async deleteItemsFromStorage(app_id, itemsForDelete = []) {
    const app = await this.appProcessor.getApp(app_id);
    if (app) {
      app.items_list = app.items_list.filter(item => {
        if(itemsForDelete.find(findedItem => item.item_id == findedItem.item_id)) {
          delete app.items_object[item.item_id];
          return false;
        }
        return true;
      });
      this.pipeService.emit("gh_items_update", { app_id }, app.items_list);
      this.storage.updateApp(app);
    }
  }

  async getItems(app_id, trash = false) {
    const app = await this.appProcessor.getApp(app_id, trash);
    if(!app) return null;
    return app.items_list;
  }

  async addNewItems(app_id, itemsList) {
    const preparedItemsList = itemsList.map((item) => ({
      ...item,
      fields: filterFields(item.fields),
    }));
    const newItems = await this.addItemsApi(app_id, preparedItemsList);
    await this.addItemsToStorage(app_id, newItems);
    this.pipeService.emit("gh_items_add", { app_id }, newItems);
    return newItems;
  }

  async updateItems(app_id, itemsList) {
    const preparedItemsList = itemsList.map((item) => ({
      ...item,
      fields: filterFields(item.fields),
    }));
    const updatedItems = await this.updateItemsApi(app_id, preparedItemsList);
    return await this.updateItemsInStorage(app_id, updatedItems);
  }

  async deleteItems(app_id, itemsIds) {
    return this.deleteItemsApi(itemsIds).then(async (items) =>
      await this.deleteItemsFromStorage(app_id, items)
    );
  }

  itemListeners() {
    this.pipeService.onRoot("gh_items_get", {}, async (event, data) => {
      if(data && data.app_id) {
        const items = await this.getItems(data.app_id);
        if (items) {
          this.pipeService.emit("gh_items_get", data, items);
        } else {
          this.pipeService.emit("gh_items_get", data, []);
        }
      }
    });

    this.pipeService.onRoot("gh_items_add", {}, async (event, data) => {
      if(data && data.app_id && data.items) {
        const items = await this.addNewItems(data.app_id, data.items);
        if (items) {
          this.pipeService.emit("gh_items_add", data, items);
        } else {
          this.pipeService.emit("gh_items_add", data, []);
        }
      }
    });

    this.pipeService.onRoot("gh_items_update", {}, async (event, data) => {
      if(data && data.app_id && data.items) {
        const items = await this.updateItems(data.app_id, data.items);
        if (items) {
          this.pipeService.emit("gh_items_update", data, items);
        } else {
          this.pipeService.emit("gh_items_update", data, []);
        }
      }
    });

    /* ---- FIELD VALUE GET LISTENING ---- */
    this.pipeService.onRoot("gh_item_get", {}, async (event, data) => {
      if(data && data.app_id){
        const items = await this.getItems(data.app_id);
        const item = items.find((item) => item.item_id == data.item_id);
        this.pipeService.emit("gh_item_get", data, item);
      }
    });

    // GETTING FILTERED ITEM
    /* data = {
                                      app_id: current appId,
                                      element_app_id: for reference appId,
                                      itemsId: current itemId,
                                      filters_list: filters list,
                                      field_groupe ?: field group,
                                      search?: search value,
                                    }
                                 */
    this.pipeService.onRoot(
      "gh_filtered_items_get",
      {},

      async (event, data) => {
        if(data && data.element_app_id) {
          const items = await this.getItems(data.element_app_id);
          const filteredItems = await this.util.getFilteredItems(
            items,
            data.filters_list,
            data.element_app_id,
            data.app_id,
            data.item_id,
            data.field_groupe,
            data.search,
            data.search_params
          );
          this.pipeService.emit("gh_filtered_items_get", data, filteredItems);
        }
      }
    );

    this.pipeService.onRoot("gh_filter_items", {}, async (event, data) => {
      if(data && data.items) {
        const filteredItems = await this.util.getFilteredItems(
          data.items,
          data.filters_list,
          data.element_app_id,
          data.app_id,
          data.item_id,
          data.field_groupe,
          data.search,
          data.search_params
        );
        this.pipeService.emit("gh_filter_items", data, filteredItems);
      }
    });
  }
}
